import { Breadcrumb, Layout } from 'antd';
import styled, { css } from 'styled-components';

const sizes = {
  xs: 480,
  sm: 576,
  md: 1000,
  lg: 1500,
  xl: 1920,
  xxl: 1920,
};

export const StyledBreadcrumb = styled(Breadcrumb)`
  background-color: var(--colorBgContainer);
  padding: 12px 24px;

  a:hover {
    background-color: initial;
  }
`;

export const PageContent = styled(Layout.Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px;

  ${({ size }) =>
    sizes[size] &&
    css`
      width: 100%;
      max-width: ${sizes[size] + 48}px;
      margin: auto;
    `}

  > * {
    width: 100%;
  }
`;
